import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const verifyEmail = async () => {
      const key = searchParams.get('key');
      if (!key) {
        setMessage('Invalid verification link.');
        return;
      }

      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/verify?key=${key}`);
        setMessage(response.data || 'Email verified successfully!');
      } catch (err) {
        console.error('Error verifying email:', err);
        setMessage(err.response?.data || 'Failed to verify email.');
      }
    };

    verifyEmail();
  }, [searchParams]);

  return <div>{message}</div>;
};

export default VerifyEmail;